import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './PaymentConfigurationList.css';

class PaymentConfigurationList extends Component {
  render() {
    const { onItemClick, selectedId, configurations } = this.props;

    const bodyRows = configurations.map(config => {
      const { id, name, assignedOutletNum } = config;

      const rowStyles = classNames(styles.tableRow, {
        [styles.selectedRow]: id === selectedId,
      });

      return (
        <tr className={rowStyles} key={id} onClick={() => onItemClick(id)}>
          <td>{name}</td>
          <td>{assignedOutletNum} Outlets</td>
        </tr>
      );
    });

    return (
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.tableHeader}>Configuration Name</th>
            <th className={styles.tableHeader}>Assigned Outlet</th>
          </tr>
        </thead>

        <tbody className="paycon-ftue-list">{bodyRows}</tbody>
      </table>
    );
  }
}

PaymentConfigurationList.defaultProps = {
  selectedId: null,
  configurations: [],
  onItemClick: () => {},
};

PaymentConfigurationList.propTypes = {
  selectedId: PropTypes.number,
  configurations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      assignedOutletNum: PropTypes.number.isRequired,
    })
  ),
  onItemClick: PropTypes.func,
};

export default PaymentConfigurationList;
